import React from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonFooter,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonText
} from '@ionic/react';
import { Formik } from 'formik';
import uniqBy from 'lodash/uniqBy';
import Field from 'src/components/Field';
import Icon from 'src/components/Icon';
import Subscribe from 'src/components/Subscribe';
import app from 'src/feathers';
import { formatDistanceToNow, diff, formatDate } from 'src/lib/time';
import './style.scss';

class ChatModal extends React.Component {
  state = { comments: [], total: 0 };
  service = app.service('api/job-comments');

  handleDidPresent = (event) => {
    // used instead of componentDidMount because the modals stay mounted
    this.getComments();
    this.setListener();
    this.setCommentsSeen();
  };

  handleDidDismiss = (event) => {
    // used instead of componentDidUnMount because the modals stay mounted
    this.clearListener();
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  setListener = () => {
    this.clearListener();
    this.commentsListener = (data) => {
      const { jobId } = this.props;
      if (data.job_id === jobId) {
        this.setState(
          { comments: [...this.state.comments, data] },
          this.scrollToBottom('smooth')
        );
      }
    };
    this.service.on('created', this.commentsListener);
  };

  clearListener = () => {
    if (this.commentsListener) {
      this.service.off('created', this.commentsListener);
    }
    this.commentsListener = null;
  };

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   const oldLength = prevState.comments.length;
  //   const newLength = this.state.comments.length;
  //   if (oldLength !== newLength) {
  //     console.log('I should be scrolling');
  //     const behavior = oldLength === 0 ? 'auto' : 'smooth';
  //     this.scrollToBottom(behavior);
  //   }
  // }

  setCommentsSeen = async () => {
    const { jobId, user } = this.props;
    return this.service.patch(
      null,
      {
        $push: { seen_by: user._id }
      },
      {
        query: {
          job_id: jobId,
          user_id: { $ne: user._id },
          seen_by: { $ne: user._id }
        }
      }
    );
  };

  getComments = (query) => {
    return this.service
      .find({
        query: {
          job_id: this.props.jobId,
          $sort: { created_at: -1 },
          ...query
        }
      })
      .then(({ data, total }) => {
        const comments = uniqBy([...data, ...this.state.comments], '_id').sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        this.setState(
          {
            comments,
            total
          },
          () => this.scrollToBottom('auto')
        );
      });
  };

  scrollToBottom = (behavior = 'smooth') => {
    if (this.commentsBottomRef) {
      setTimeout(
        () => this.commentsBottomRef.scrollIntoView({ behavior, block: 'end' }),
        0
      );
    }
  };

  handleSubmit = (data, formik, event) => {
    formik.setSubmitting(true);
    this.service
      .create({
        text: data.text,
        job_id: this.props.jobId
      })
      .then((data) => {
        formik.resetForm();
        console.log(this.commentInput);
        // this.commentInput.focus();
      })
      .catch((error) => {
        if (error.errors) {
          formik.setErrors(error.errors);
        }
        this.commentInput.focus();
        formik.setSubmitting(false);
      });
  };

  render() {
    const { isOpen, user } = this.props;
    const { comments } = this.state;
    return (
      <React.Fragment>
        <IonModal
          isOpen={isOpen}
          onDidPresent={this.handleDidPresent}
          onDidDismiss={this.handleDidDismiss}
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Chat</IonTitle>
              <IonButtons slot="end">
                <IonButton onclick={this.handleClose}>Close</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonGrid className="comments">
              {comments.map((comment) => (
                <IonRow key={comment._id} className="mb-3">
                  <Comment user={user} comment={comment} />
                </IonRow>
              ))}
            </IonGrid>
            <div
              ref={(ref) => {
                this.commentsBottomRef = ref;
              }}
            />
          </IonContent>
          <IonFooter>
            <IonToolbar>
              <Formik
                initialValues={{ text: '' }}
                onSubmit={this.handleSubmit}
                render={(formik) => {
                  return (
                    <IonRow className="chat-footer align-items-center">
                      <IonCol size="10">
                        <Field
                          name="text"
                          type="textarea"
                          rows="1"
                          autoGrow={formik.values.text.length > 30}
                          disabled={formik.isSubmitting}
                          // onKeyDown={event => {
                          //   if (event.key === 'Enter') {
                          //     event.preventDefault();
                          //     this.handleSubmit(formik.values, formik);
                          //   }
                          // }}
                          inputRef={(ref) => {
                            this.commentInput = ref;
                          }}
                        />
                      </IonCol>
                      <IonCol size="2">
                        <IonButton
                          expand="block"
                          disabled={formik.isSubmitting}
                          onClick={() =>
                            this.handleSubmit(formik.values, formik)
                          }
                        >
                          <Icon type="paper-plane" />
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  );
                }}
              />
            </IonToolbar>
          </IonFooter>
        </IonModal>
      </React.Fragment>
    );
  }
}

const Comment = ({ comment, user }) => {
  const isMine = (comment) => comment.user_id === user._id;
  return (
    <IonCol size="11" offset={isMine(comment) ? '0' : '1'}>
      <div className="d-flex">
        <div style={isMine(comment) ? {} : { marginLeft: 'auto' }}>
          <div className={`comment ${isMine(comment) ? 'mine' : ''}`}>
            <p className="lead mb-0">{comment.text}</p>
          </div>
        </div>
      </div>
      <p
        className={`small mt-1 mb-0 ${isMine(comment) ? '' : 'ion-text-right'}`}
      >
        <IonText color="medium">
          {comment.user.full_name},{' '}
          {diff(comment.created_at, new Date(), 'hours') < 24
            ? formatDistanceToNow(comment.created_at)
            : formatDate(comment.created_at, 'dateTime')}
        </IonText>
      </p>
    </IonCol>
  );
};

export default (props) => (
  <Subscribe
    render={(container) => <ChatModal {...props} user={container.state.user} />}
  />
);
